import React from 'react'
import { Link } from 'gatsby'

import { HBox, Wrapper } from 'src/ui/layout'
import { Hero } from 'src/ui/organisms'
import { Body, Header } from 'src/ui/typography'
import { Image } from 'src/ui/atoms'

type Props = {
  images: TImages
}

export const Learn: React.FC<Props> = ({ images }) => (
  <Wrapper>
    <Image fluid={images['learn']} />
    <HBox />
    <Header as="h4" size="h4">
      Групповые и менторские стажировки
    </Header>
    <HBox />
    <Body>
      С&nbsp;2016&nbsp;года KODE проводит стажировки
      по&nbsp;10&nbsp;направлениям, включая мобильную и веб-разработку,
      управление проектами, аналитику, QA-тестирование и&nbsp;дизайн.
    </Body>
    <HBox />
    <Body weight="medium">
      <a href="https://edu.kode.ru/" target="_blank">
        Больше о&nbsp;стажировках KODE&nbsp;→
      </a>
    </Body>
  </Wrapper>
)
